<template lang="pug">
.temporaryArticles
  SectionTitle(
    :sectionText="title"
    :displayCardCounter="false"
    :displaySeeMoreText="false"
  )
  .articleWithThumbnail-buttons.overrideButtonsStyle(v-if="partnerLink.length > 0")
    a.articleWithThumbnail-button.articleWithThumbnail-forwardButton.overrideButtonStyle(
      v-for="partnerItem in partnerLink"
      :href="partnerItem.urlInPartner"
      target="_blank"
    )
      span {{ partnerItem.partner.name}}
  div(v-else)
    span No data
</template>

<script>
import LatestArticles from "@/components/latest_articles/latest_article.vue";
import SectionTitle from "@/components/modules/section_title/section_title.vue";
export default {
  props: {
    title: String,
    partnerLink: Array,
  },
  components: {
    LatestArticles,
    SectionTitle,
  },
};
</script>

<style src="./article_in_partners_block.vue.css"></style>
